/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_SuccessInputs */

const vi_chot_so_success = /** @type {(inputs: Chot_So_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã chốt sổ`)
};

/**

* @param {Chot_So_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_success = /** @type {((inputs?: Chot_So_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_success(inputs)
});